export const getInventory = state => {
  return state.inventory;
};
export const getOwnedProducts = state => {
  const inventory = getInventory(state);
  return inventory && inventory.ownedProducts;
};